import { useContext, useEffect, useState } from 'react'
import Context from './Context'
// Antd
import { SearchOutlined } from '@ant-design/icons'
import { Button, Input, message } from 'antd'
import { MdOutlinePersonAddAlt1 } from 'react-icons/md'
// components
import BaseLayout from 'components/BaseLayout'
import TableComponent from 'components/Table'
import Modal from './Modal'
import { ColumnsType } from 'components/Table/interface'
// helpers
import toLower from 'lodash/toLower'
import filter from 'lodash/filter'
import isEmpty from 'lodash/isEmpty'
import MoreOptions from './Cells/MoreActions'
import StatusCell from './Cells/StatusCell'
import AgoDateCell from './Cells/DateCell'
import RolesCell from './Cells/RolesCell'
import SelectFilter from 'components/SelectFilter'
import UserCell from './Cells/UserCell'

const columns: ColumnsType<any> = [
  {
    title: 'Usuario',
    dataIndex: 'firstname',
    render: UserCell
  },
  {
    title: 'Email',
    dataIndex: 'username',
    type: 'CommonCell'
  },
  {
    title: 'Estado',
    dataIndex: 'active',
    render: StatusCell
  },
  {
    title: 'Roles',
    dataIndex: 'roles',
    render: RolesCell
  },
  {
    title: "Fecha de Creación",
    dataIndex: 'created_at',
    type: "date"
  },
  {
    title: "Fecha de actualización",
    dataIndex: 'updated_at',
    type: "date"
  },
  {
    title: "Último acceso",
    dataIndex: 'last_login',
    render: AgoDateCell
  },
  {
    title: '',
    dataIndex: 'firstname',
    render: MoreOptions
  }
]

const Layout: React.FC = () => {
  const {
    states: { filterSelected, page, searchInput, selectedUser, open, roles, typeSelected },
    actions: { setFilterSelected, setPage, setSearchInput, onOpen, setTypeSelected },
    queryHandler: { isFetching, data }
  } = useContext(Context)

  const filterData = () => {
    return filter(data, ({ username, firstname, lastname }) => {
      if (isEmpty(searchInput)) return true

      return username.includes(searchInput) || toLower(`${firstname} ${lastname}`).includes(toLower(searchInput))
    }).filter(({ active }) => {
      if (!filterSelected) return true

      return active === (filterSelected === 'activo')
    }).filter(({ roles }) => {
      if (!typeSelected) return true

      return roles.includes(typeSelected)
    })
  }

  const filteredData = filterData()

  return (
    <>
      <BaseLayout
        title="Usuarios"
        bordered={false}
        extra={
          <Button icon={<MdOutlinePersonAddAlt1 />} type="primary" style={{ display: 'flex', alignItems: 'center', }} onClick={() => onOpen('createUser')}>
            Agregar usuario
          </Button>
        }
      >
        <Input
          size="large"
          placeholder="Busca por nombre o email"
          prefix={<SearchOutlined />}
          value={searchInput}
          onChange={e => setSearchInput(e.target.value)}
        />
        <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center', gap: '1rem' }}>
          <SelectFilter
            options={[
              { value: 'inactivo', label: 'Inactivo' },
              { value: 'activo', label: 'Activo' }
            ]}
            value={filterSelected}
            setValue={setFilterSelected}
            placeholder='Seleccione un estado'
          />
          <SelectFilter
            options={roles.map(({ name, role }) => ({ label: name, value: role }))}
            value={typeSelected}
            hideIcon
            setValue={setTypeSelected}
            placeholder='Rol'
            noBadge
          />
        </div>
        <TableComponent
          emptyData={filteredData.length === 0 && !isFetching}
          columns={columns}
          data={filteredData.slice((page - 1) * 9, page * 9)}
          rows={9}
          loading={isFetching}
          page={page}
          total={filteredData.length}
          setPage={setPage}
        />
      </BaseLayout>
      <Modal key={`${selectedUser}-${open}`} />
    </>
  )
}

export default Layout
